export const meta = {
  appAlias: 'job-board',
  appName: 'Job Board'
};
